import { translate } from 'react-jhipster';
import { notification } from 'antd';
import { isFulfilledAction, isRejectedAction } from 'app/shared/reducers/reducer.utils';

function addErrorAlert(message, key?, data?) {
  key = key ? key : message;
  notification.error({
    message: translate(key, data),
    placement: 'topRight',
    top: 80,
  });
}

function handleFulfilledAction(action) {
  const { payload } = action;
  if (payload && payload.headers) {
    const headers = payload.headers;
    let alert: string | null = null;
    let alertParams: string | null = null;
    headers &&
      Object.entries<string>(headers).forEach(([k, v]) => {
        if (k.toLowerCase().endsWith('app-alert')) {
          alert = v;
        } else if (k.toLowerCase().endsWith('app-params')) {
          alertParams = decodeURIComponent(v.replace(/\+/g, ' '));
        }
      });
    if (alert) {
      const alertParam = alertParams;
      notification.success({
        message: translate(alert, { param: alertParam }),
        placement: 'topRight',
        top: 80,
      });
    }
  }
}

function handleRejectedAction(action) {
  const { error } = action;
  if (error && error.isAxiosError) {
    if (error.response) {
      const response = error.response;
      const data = response.data;
      if (
        !(
          response.status === 401 &&
          (error.message === '' || (data && data.path && (data.path.includes('/api/account') || data.path.includes('/api/authenticate'))))
        )
      ) {
        handleResponseError(response, data);
      }
    } else if (error.config && error.config.url === 'api/account' && error.config.method === 'get') {
      console.error('Authentication Error: Trying to access url api/account with GET.');
    } else {
      notification.error({
        message: error.message || 'Unknown error!',
        placement: 'topRight',
        top: 80,
      });
    }
  } else if (error) {
    notification.error({
      message: error.message || 'Unknown error!',
      placement: 'topRight',
      top: 80,
    });
  }
}

function handleResponseError(response, data) {
  switch (response.status) {
    case 0: {
      addErrorAlert('Server not reachable', 'error.server.not.reachable');
      break;
    }
    case 400: {
      handleBadRequest(response, data);
      break;
    }
    case 404: {
      addErrorAlert('Not found', 'error.url.not.found');
      break;
    }
    default: {
      let errorMessage = 'Unknown error!';
      if (typeof data === 'string' && data !== '') {
        errorMessage = data;
      } else if (data) {
        if (data.detail && typeof data.detail === 'string' && data.detail.startsWith('{code=')) {
          const errorCode = parseInt(data.detail.match(/code=(\d+)/)[1], 10);
          errorMessage = getCustomErrorMessage(errorCode);
        } else {
          errorMessage = data.detail || data.message || data.error || data.title || errorMessage;
        }
      }
      notification.error({
        message: errorMessage,
        placement: 'topRight',
        top: 80,
      });
      break;
    }
  }
}

const getCustomErrorMessage = errorCode => {
  switch (errorCode) {
    case 2021:
      return "Le solde de votre compte ne vous permet pas d'effectuer cette opération. Merci de recommencer.";
    case 2040:
      return "Vous venez d'effectuer une transaction identique. Merci de recommencer dans 15 minutes.";
    default:
      return "Une erreur est survenue lors de l'opération. Merci de réessayer dans quelques minutes.";
  }
};

function handleBadRequest(response, data) {
  let errorHeader: string | null = null;
  let entityKey: string | null = null;
  response?.headers &&
    Object.entries<string>(response.headers).forEach(([k, v]) => {
      if (k.toLowerCase().endsWith('app-error')) {
        errorHeader = v;
      } else if (k.toLowerCase().endsWith('app-params')) {
        entityKey = v;
      }
    });
  if (errorHeader) {
    const normalizedEntityKey = entityKey ? entityKey.charAt(0).toLowerCase() + entityKey.slice(1) : entityKey;
    const entityName = translate('global.menu.entities.' + normalizedEntityKey);
    addErrorAlert(errorHeader, errorHeader, { entityName });
  } else if (data?.fieldErrors) {
    handleFieldErrors(data.fieldErrors);
  } else if (typeof data === 'string' && data !== '') {
    addErrorAlert(data);
  } else {
    notification.error({
      message: data?.message || data?.error || data?.title || 'Unknown error!',
      placement: 'topRight',
      top: 80,
    });
  }
}

function handleFieldErrors(fieldErrors) {
  for (let i = 0; i < fieldErrors.length; i++) {
    const fieldError = fieldErrors[i];
    if (['Min', 'Max', 'DecimalMin', 'DecimalMax'].includes(fieldError.message)) {
      fieldError.message = 'Size';
    }
    const convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
    const fieldName = translate(`korischoolApp.${fieldError.objectName}.${convertedField}`);
    addErrorAlert(`Error on field "${fieldName}"`, `error.${fieldError.message}`, { fieldName });
  }
}

export default () => next => action => {
  if (isFulfilledAction(action)) {
    handleFulfilledAction(action);
  } else if (isRejectedAction(action)) {
    handleRejectedAction(action);
  }

  return next(action);
};
